export const PAYRUN_SUMMARY_VIEW_LOAD = 'PAYRUN_SUMMARY_VIEW_LOAD'
export const PAYRUN_SUMMARY_VIEW_LOAD_PENDING = 'PAYRUN_SUMMARY_VIEW_LOAD_PENDING'
export const PAYRUN_SUMMARY_VIEW_LOAD_FULFILLED = 'PAYRUN_SUMMARY_VIEW_LOAD_FULFILLED'
export const PAYRUN_SUMMARY_VIEW_LOAD_REJECTED = 'PAYRUN_SUMMARY_VIEW_LOAD_REJECTED'

export const CONTROLL_SEARCH_BAR = 'CONTROLL_SEARCH_BAR'
